import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const argentineNames = ['Martín', 'Lucía', 'Santiago', 'Valentina', 'Mateo', 'Sofía', 'Benjamín', 'Emma', 'Joaquín', 'Isabella', 'Tomás', 'Mía', 'Nicolás', 'Catalina', 'Felipe', 'Camila', 'Diego', 'Florencia', 'Agustín', 'Victoria', 'Franco', 'Julieta', 'Lucas', 'Martina', 'Rodrigo', 'Ana', 'Ignacio', 'Paula', 'Facundo', 'Carolina'];
const argentineCities = ['Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta', 'Neuquén', 'Bariloche', 'San Juan', 'Resistencia', 'Paraná', 'Posadas', 'Santa Fe', 'San Miguel de Tucumán', 'Corrientes', 'Bahía Blanca', 'San Salvador de Jujuy'];
export function PurchasePopup() {
  const [notifications, setNotifications] = useState<Array<{
    id: number;
    name: string;
    city: string;
    minutes: number;
  }>>([]);
  const [nextId, setNextId] = useState(0);
  useEffect(() => {
    const showNotification = () => {
      const randomName = argentineNames[Math.floor(Math.random() * argentineNames.length)];
      const randomCity = argentineCities[Math.floor(Math.random() * argentineCities.length)];
      const randomMinutes = Math.floor(Math.random() * 30) + 1;
      setNextId(prev => {
        const id = prev;
        const newNotification = {
          id,
          name: randomName,
          city: randomCity,
          minutes: randomMinutes
        };
        setNotifications(current => [...current, newNotification]);
        setTimeout(() => {
          setNotifications(current => current.filter(n => n.id !== id));
        }, 5000);
        return prev + 1;
      });
    };
    // Show every 30 seconds
    const interval = setInterval(showNotification, 30000);
    const initialTimeout = setTimeout(showNotification, 3000);
    return () => {
      clearInterval(interval);
      clearTimeout(initialTimeout);
    };
  }, []);
  return <div className="fixed bottom-6 left-6 z-50 space-y-3" data-id="element-332">
      <AnimatePresence data-id="element-333">
        {notifications.map(notification => <motion.div key={notification.id} initial={{
        x: -400,
        opacity: 0
      }} animate={{
        x: 0,
        opacity: 1
      }} exit={{
        x: -400,
        opacity: 0
      }} className="bg-white rounded-lg shadow-2xl p-4 border-l-4 border-green-500 max-w-sm" data-id="element-334">
            <div className="flex items-start gap-3" data-id="element-335">
              <div className="text-2xl" data-id="element-336">🎉</div>
              <div className="flex-1" data-id="element-337">
                <p className="font-bold text-slate-900 text-sm" data-id="element-338">
                  {notification.name} de {notification.city}
                </p>
                <p className="text-slate-600 text-sm" data-id="element-339">
                  acaba de comprar Rescate Académico
                </p>
                <p className="text-slate-500 text-xs mt-1" data-id="element-340">
                  hace {notification.minutes} minutos
                </p>
              </div>
            </div>
          </motion.div>)}
      </AnimatePresence>
    </div>;
}